import React, { useState } from 'react';
import ModalMedia from "@directv-digital/fusion.organisms.modal-media";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import FusionTextField from "@directv-digital/fusion.molecules.text-field";
import DtvEmailCapture from "@directv-digital/dds.ui.dtv-email-capture";
import { fireCustomLinkClickGA, fireModalOpenCloseEventGA } from "@directv-digital/dds.services.analytics-service";

const PurchaseLikelihoodModal = ({ modalOpen, onClose, content }) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");

  const handleSignUp = async () => {
    const regExp = new RegExp(
      "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-][a-zA-Z0-9-]+\\.[a-zA-Z0-9-.][a-zA-Z0-9-.]+$"
    );
    if(regExp.test(email)){
      const martech = { user_id_hash_email: email.toString() || '' };
      handleAnalyticEvents('lead_capture', 'contact type', 'martech', martech);
      const response = await fetch(
        '/shop/api/otp/validateEmail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email,
            mode: "EXPERIAN"
          })
        }
      );
      const res = await response.json();
      if (res.validationStatus === "success") {
        window.sessionStorage?.setItem("ffpEmail", email);
        window.location.href = `${content?.signUpCta?.targeturl || '/shop/myfree-directv'}`
      } else if (res.error === "EXPERIAN_MAX_VALIDATIONS_ATTEMPTS") {
        setEmailError(true);
        setEmailErrorMsg("Max attempts reached. Please try again in sometime"); // TO-DO: to check and make this content CI configurable
      } else {
        setEmailError(true)
      }
    } else {
      setEmailError(true);
    }
  }

  const handleSecondaryButton = (targetUrl:any, buttonLabel:string) => {
    window.location.href = targetUrl;
    handleAnalyticGAEvents(buttonLabel?.toLowerCase(), window?.location?.href)
  }

  const handleAnalyticGAEvents = (label:any, url:string) => {
    fireCustomLinkClickGA({
      event: 'trackEvent',
      event_name: `custom_link_click`,
      linkName: `${label}`,
      linkPosition: `marketing_ai_modal`,
      linkDestination: `${url}`
    });
  };

  const handleAnalyticEvents = (eventName, label:any, value:string, additionalData?:any) => {
    fireModalOpenCloseEventGA({
      event: 'trackEvent',
      event_name: `${eventName}`,
      dim_name: `${label}`,
      dim_value: `${value}`,
      martech: additionalData
    });
  }

  if (!modalOpen) {
    return null;
  }

  return (
  <DtvBox data-testid="purchase-likelihood-modal">
    <ModalMedia
      content={content?.mainContent}
      handleClose={onClose}
      image={content?.image?.url}
      legalText={content?.legalText}
      open={modalOpen}
      primaryButtonText={content?.cta?.label}
      secondaryButtonClick={() => handleSecondaryButton(content?.optionalCta?.targeturl, content?.optionalCta?.label)}
      secondaryButtonText={content?.optionalCta?.label}
      secondaryButtonVisible={!content?.optionalCta?.disabled}
      subtitle={content?.subtitle}
      title={content?.title}
      primaryButtonClick={() => {
        if (content?.cta?.label === 'Sign Up' && content?.emailLabel) {
          handleSignUp();
        } else {
          window.location.href = content?.cta?.targeturl;
          handleAnalyticGAEvents(content?.cta?.label?.toLowerCase(), window.location.href);
        }
      }}
    >
      {content?.emailLabel && !content?.emailCapture  && (
        <DtvBox
          id="email"
          sx={{
            paddingTop: {
 xs: "20px",
sm: "24px",
md: "32px"
},
            marginLeft: {
 xs: "20px",
sm: "32px",
md: "48px"
},
            marginRight: {
 xs: "20px",
sm: "32px",
md: "48px"
}
          }}
        >
          <DtvBox sx={{
 minHeight: {
 xs: "80px",
sm: "80px",
md: "88px"
}
}}>
            <FusionTextField
              error={emailError}
              helperMessage={!!emailError}
              helperMessageIcon={!!emailError}
              label={content?.emailLabel}
              value={email}
              helperMessageText={
                emailError ?
                  emailErrorMsg !== "" ?
                    emailErrorMsg :
                    content?.emailErrorMessage :
                  " "
              }
              width={
                window.innerWidth <= 599 ? "100%" : null
              }
              onChange={e => {
                setEmail(e?.target?.value);
                setEmailError(false);
                setEmailErrorMsg("");
              }}
            />
          </DtvBox>
        </DtvBox>
      )}
      {!content?.emailLabel && content?.emailCapture && (
        <DtvBox className="marketAiModalEmailCapture"
        sx={{
          '& button#emailCapture': {
            background: 'transparent'
          },
          '& #emailAddress-helper-text p': {
            color: "#E35A4D"
          },
          '& #quadro-thankYouPage': {
            '& div:first-of-type': {
              alignItems: "flex-start"
            }
          }
        }}
        >
        <DtvEmailCapture {...content?.emailCapture}
      />
        </DtvBox>
    )}
    </ModalMedia>
    </DtvBox>
  );
};

export default PurchaseLikelihoodModal;
